import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { IApiResponse, ICmsStationResponse } from "../../Orchestrator/Types/Index";

export async function getCmsJourneyPlannerStation(): Promise<IApiResponse<ICmsStationResponse>> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getNetworkMapStations;

  const params = new URLSearchParams({
    locale: await getLocaleFromCookie(),
    "populate[station][populate]": "image",
    "populate[car_taxis][populate]": "logo",
    "populate[car_rentals][populate]": "logo",
    "populate[car_parking][populate]": "true",
    "populate[metro_stations][populate]": "true",
    "populate[bus_stops][populate][bus_routes][populate]": "true",
    "populate[shuttle_routes][populate][origin]": "true",
    "populate[shuttle_routes][populate][destination]": "true",
  });

  let endpointWithParams = `${endpoint}?${params.toString()}`;
  return await cmsApiRequest<ICmsStationResponse>(endpointWithParams, "GET");
}
